import LayoutHero from './layouts/Layout1'
import Layout10 from './layouts/Layout10'
import LayoutTwoColumn from './layouts/Layout2'
import LayoutBanner from './layouts/Layout3'
import Layout4 from './layouts/Layout4'
import Layout5 from './layouts/Layout5'
import Layout6 from './layouts/Layout6'
import Layout7 from './layouts/Layout7'
import Layout8 from './layouts/Layout8'
import Layout9 from './layouts/Layout9'
import Layout11 from './layouts/Layouts11'

export const LAYOUT_REGISTRY = {
  1: LayoutHero,
  2: LayoutTwoColumn,
  3: LayoutBanner,
  4: Layout4,
  5: Layout5,
  6: Layout6,
  7: Layout7,
  8: Layout8,
  9: Layout9,
  10: Layout10,
  11: Layout11,
}
